<template>
    <div class="cms-container">
        <div v-if="showFilterModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <div class="modal-content bg-white overflow-hidden" @click.stop>
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">Filter</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModals">close</button>
                </div>
                <form class="modal-body mt-1" @submit.prevent="applyFilters">
                    <div class="d-flex align-items-center justify-content-center" style="gap:5px;">
                        <div class="w-100">
                            <label for="fromdate" class="text-dark">From:</label>
                            <input type="date" v-model="tempFromDate" id="fromdate" class="w-100 text-dark px-1"
                                style="outline:none; height:30px;">
                        </div>
                        <div class="w-100">
                            <label for="todate" class="text-dark">To:</label>
                            <input type="date" v-model="tempToDate" id="todate" class="w-100 text-dark px-1"
                                style="outline:none; height:30px;">
                        </div>
                    </div>
                    <div class="modal-actions d-flex justify-content-end mt-3" style="gap:10px;">
                        <button type="submit" class="vmc-bg-prime-5 rounded px-3 py-1 text-white border-0">Search
                            Filter</button>
                        <button type="button" class="vmc-bg-prime-4 rounded px-3 py-1 text-white border-0"
                            @click="closeModals">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="vmc-card">
            <div class="card-container d-lg-flex">
                <div class="cards w-100 my-2 text-dark px-2 py-1">
                    Total Crews
                    <h2 class="text-dark h4">{{ totalCrews || '-' }}</h2>
                </div>
                <div class="cards w-100 my-2 text-dark px-2 py-1">
                    On Board
                    <h2 class="text-dark h4">{{ onBoard || '-' }}</h2>
                </div>
                <div class="cards w-100 my-2 text-dark px-2 py-1">
                    Standby
                    <h2 class="text-dark h4">{{ standBy || '-' }}</h2>
                </div>
                <div class="cards w-100 my-2 text-dark px-2 py-1">
                    Total Vessel
                    <h2 class="text-dark h4">{{ totalVessels || '-' }}</h2>
                </div>
            </div>
            <div class="card-container d-xl-flex">
                <div class="left-container mt-4">
                    <div class="news-card w-100">
                        <div class="news-header text-dark px-2 py-3 border border-dark border-bottom-0">News Lists</div>
                        <div class="news-scrollable-list border border-dark">
                            <div v-if="newsArticles.length === 0" class="news-item p-2 text-dark text-center">
                                No news articles.
                            </div>
                            <div v-for="(article, index) in newsArticles" :key="index"
                                class="news-item p-2 border border-dark border-top-0 border-left-0 border-right-0 border-bottom">
                                <div class="news-title text-dark">{{ article.title }}</div>
                                <div class="news-status mt-2 text-dark">Category: {{ article.category }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-container mt-4">
                    <div class="job-card w-100">
                        <div class="job-header text-dark px-2 py-3 border border-dark border-bottom-0">Job Lists</div>
                        <div class="job-scrollable-list border border-dark">
                            <div v-if="jobList.length === 0" class="job-item p-2 text-dark text-center">
                                No job openings.
                            </div>
                            <div v-for="(job, index) in jobList" :key="index"
                                class="job-item p-2 border border-dark border-top-0 border-left-0 border-right-0 border-bottom">
                                <div class="job-title text-dark">{{ job.title }}</div>
                                <div class="job-status mt-2 text-dark">Status: Hiring</div>
                            </div>
                        </div>
                    </div>

                    <!-- SEARCH + FILTER BAR -->
                    <div class="search-container d-md-flex align-items-md-center justify-content-md-end px-2 mt-4"
                        style="gap:10px;">
                        <div class="filter">
                            <button type="button" @click="showFilterModal = true"
                                class="d-flex align-items-center vmc-bg-prime-4 text-white border-0 rounded py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24"
                                    fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path
                                        d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
                                </svg>
                            </button>
                        </div>
                        <input type="text" v-model="searchQuery" @input="resetPage" placeholder="Search..."
                            class="search-bar text-dark p-1" style="outline:none;" />
                    </div>
                    <div class="table-container overflow-auto mt-2">
                        <table class="w-100 min-w-100">
                            <thead>
                                <tr>
                                    <th class="p-2 w-50">Name</th>
                                    <th class="p-2 w-50">Logged in</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(user, index) in paginatedUsers" :key="index"
                                    class="border border-right-0 border-left-0 border-bottom">
                                    <td class="py-3 px-2 border-left-0 border-top-0 border-right-0 text-dark">
                                        {{ user.name }}
                                    </td>
                                    <td class="py-3 px-2 border-left-0 border-top-0 border-right-0 text-dark">
                                        {{ user.date }}<br>
                                        {{ user.time }}
                                    </td>
                                </tr>
                                <tr v-if="paginatedUsers.length === 0" class="border-bottom">
                                    <td colspan="4" class="text-dark text-center p-2">
                                        No data found.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr class="px-0">
                    <div class="table-footer" style="padding:0 10px;">
                        <div class="d-flex align-items-center justify-content-center">
                            <p v-if="filteredUsers.length === 0" style="font-weight:400; color: #212529;">
                                Showing 0 to 0 of 0 entries
                            </p>
                            <p v-else-if="filteredUsers.length === 1" style="font-weight:400; color: #212529;">
                                Showing 1 to 1 of 1 entry
                            </p>
                            <p v-else style="font-weight:400; color: #212529;">
                                Showing {{ entryStart }} to {{ entryEnd }} of {{ filteredUsers.length }} entries
                            </p>
                        </div>
                        <div class="d-flex align-items-center justify-content-center">
                            <p class="next-previous" @click="firstPage" :disabled="currentPage === 1"
                                style="border:none; cursor:pointer;">&#60;&#60;</p>
                            <p class="next-previous" @click="prevPage" :disabled="currentPage === 1"
                                style="border:none; padding:0 10px; cursor:pointer;">&#60;</p>
                            <p v-if="paginatedUsers.length === 0" class="mx-2">{{ totalPages }} of {{ totalPages }}</p>
                            <p v-else class="mx-2">{{ currentPage }} of {{ totalPages }}</p>
                            <p class="next-previous" @click="nextPage" :disabled="currentPage === totalPages"
                                style="border:none; padding:0 10px; cursor:pointer;">&#62;</p>
                            <p class="next-previous" @click="lastPage" :disabled="currentPage === totalPages"
                                style="border:none; cursor:pointer;">&#62;&#62;</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DashboardCMS",
    data() {
        return {
            onBoard: 0,
            standBy: 0,
            totalVessels: 0,
            jobList: [],
            newsArticles: [],
            currentPage: 1,
            perPage: 10,
            searchQuery: '',
            tempFromDate: '',
            tempToDate: '',
            selectedFromDate: '',
            selectedToDate: '',
            showFilterModal: false,
            users: []
        }
    },

    async mounted() {
        await this.loadStats();
        await this.loadLogs();
    },

    methods: {
        async loadStats() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch");

                const data = await response.json();
                this.onBoard = data.onBoard ?? 0;
                this.standBy = data.standBy ?? 0;
                this.totalVessels = data.totalVessels ?? 0;
                this.jobList = Array.isArray(data.jobList) ? data.jobList : [];
                this.newsArticles = Array.isArray(data.newsArticles)
                    ? data.newsArticles
                        .filter(a => a.title && a.author && a.category && a.content)
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                    : [];

            } catch (error) {
                console.error("Dashboard load error:", error);
            }
        },

        async loadLogs() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/logs`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Failed to fetch logs");

                this.users = await response.json();
            } catch (error) {
                console.error("Logs load error:", error);
            }
        },

        closeModals() {
            this.showFilterModal = false;
            this.editIndex = null;
        },

        applyFilters() {
            this.selectedFromDate = this.tempFromDate;
            this.selectedToDate = this.tempToDate;
            this.currentPage = 1;
            this.closeModals();
        },

        nextPage() { if (this.currentPage < this.totalPages) this.currentPage++; },
        prevPage() { if (this.currentPage > 1) this.currentPage--; },
        lastPage() { this.currentPage = this.totalPages; },
        firstPage() { this.currentPage = 1; },
        resetPage() { this.currentPage = 1; },

        onKeyboard(e) {
            if (this.showFilterModal) {
                if (e.key === 'Escape') this.closeModals();
            }
        },

        onOverlayMouseDown(e) {
            this.overlayMouseDownOnOverlay = e.target.classList.contains('modal-overlay');
        },

        onOverlayMouseUp(e) {
            if (this.overlayMouseDownOnOverlay && e.target.classList.contains('modal-overlay')) {
                this.closeModals();
            }
            this.overlayMouseDownOnOverlay = false;
        },
    },

    computed: {
        totalCrews() {
            return (Number(this.onBoard) || 0) + (Number(this.standBy) || 0);
        },

        filteredUsers() {
            let result = this.users;
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                result = result.filter(user =>
                    user.name.toLowerCase().includes(query) ||
                    user.date.includes(query) ||
                    user.time.includes(query)
                );
            }

            if (this.selectedFromDate || this.selectedToDate) {
                result = result.filter(a => {
                    if (!a.date) return false;

                    const articleDate = new Date(a.date.split(' | ')[0]);

                    if (this.selectedFromDate) {
                        const from = new Date(this.selectedFromDate);
                        if (articleDate < from) return false;
                    }

                    if (this.selectedToDate) {
                        const to = new Date(this.selectedToDate);
                        if (articleDate > to) return false;
                    }

                    return true;
                });
            }
            return result;
        },

        paginatedUsers() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredUsers.slice(start, start + this.perPage);
        },

        totalPages() {
            return Math.ceil(this.filteredUsers.length / this.perPage) || 1;
        },

        entryStart() {
            if (this.filteredUsers.length === 0) return 0;
            return (this.currentPage - 1) * this.perPage + 1;
        },

        entryEnd() {
            return Math.min(this.currentPage * this.perPage, this.filteredUsers.length);
        },
    }
}
</script>

<style scoped>
tr th {
    position: sticky;
    top: 0;
}

hr {
    border-top: 1px solid black;
}

button p,
p {
    color: #212529;
}

.next-previous {
    background-color: white;
    color: black;
}

.next-previous:disabled {
    background-color: white;
    cursor: not-allowed;
}

@media (min-width: 330px) {
    .cms-container {
        margin-bottom: 20px;
        overflow-x: hidden;
    }

    .card-container {
        gap: 12px;
        margin: 0 10px 10px 10px;
    }

    .cards {
        border: 1px solid #999;
        background-color: #f0f0f0;
        border-radius: 10px;
    }

    .left-container {
        width: 100%;
    }

    .news-header {
        font-size: 22px;
        font-weight: bold;
        border-radius: 10px 10px 0 0;
    }

    .news-scrollable-list {
        max-height: 220px;
        height: 220px;
        overflow-y: auto;
    }

    .news-item {
        box-sizing: border-box;
    }

    .news-status {
        font-size: 14px;
    }

    .job-header {
        font-size: 22px;
        font-weight: bold;
        border-radius: 10px 10px 0 0;
    }

    .job-scrollable-list {
        max-height: 250px;
        height: 250px;
        overflow-y: auto;
    }

    .job-status {
        font-size: 14px;
    }

    .job-title,
    .news-title {
        font-weight: 500;
    }

    .table-container {
        max-height: 400px;
        height: 400px;
    }

    .search-bar {
        width: 100%;
        margin-top: 10px;
    }

    table {
        border-collapse: collapse;
    }

    tr th {
        background-color: var(--vmc-primary-6);
        color: white;
    }

    tr:nth-child(even) {
        background-color: #f0f0f0;
    }

    .modal-overlay {
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .modal-content {
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        animation: slideDown 0.3s ease-out;
    }

    .modal-header {
        background-color: #f5f5f5;
        border-bottom: 1px solid #ddd;
    }

    .modal-header h2 {
        font-size: 1.2rem;
    }

    .modal-body {
        padding: 20px;
    }

    @keyframes slideDown {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
}

@media (min-width: 992px) {
    .search-bar {
        width: 200px;
        margin-top: 0;
    }

    .table-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        margin-top: 105px;
    }

    .card-container {
        margin: 0 10px 10px 10px;
    }

    .left-container {
        max-width: 60%;
        width: 100%;
    }

    .right-container {
        max-width: 40%;
        width: 100%;
    }

    .news-scrollable-list {
        max-height: 800px;
        height: 800px;
        overflow-y: auto;
    }

    .news-card {
        width: 100%;
    }

    .news-status {
        font-size: 16px;
    }

    .job-status {
        font-size: 16px;
    }

    .table-container::-webkit-scrollbar {
        width: 4px;
    }

    .table-container::-webkit-scrollbar-thumb {
        background-color: #666;
    }

    .table-container::-webkit-scrollbar-thumb:hover {
        background: #6b7280;
    }
}
</style>